// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141940/js/" + chunkId + "." + {"44":"72756ce6","225":"8fd87761","481":"159a5245","486":"1dee16b5","770":"f08bf97a"}[chunkId] + ".0.5401855130973637.chunk.js";
};